export default __webpack_public_path__ + "static/media/placeholder.9bbabeda.png";